<div class="col-lg-4 mb-3 d-flex align-items-stretch">
 <div class="card   box-shadow-3 round  w-card-seguro-mobile card-not-respo-2">
  <!-- margin-top: -234px!important; -->
  <div class="card-body">
   <h5 class="card-title  title-banner title preto-geia l-s-0 title-card-seguros"><b>{{ titulo }}</b></h5>
  </div>
  <img [src]="imagemUrl" class="card-img-icon mx-auto img-top-card  img-fluid  img-top">

  <div class="card-body" *ngIf="isCaminhao">
   <p class="card-text text-center desc-text-card-price">{{ descricao }}</p>
   <div class="justify-content-center ">
    <h2 class="card-title-caminhao">{{ preco }}<span class=" cent-value"> {{ valorCentavo }}</span></h2>

   </div>
   <div class="d-flex justify-content-center div-top-card-seguro">
    <button type="button" (click)="onCotacaoOnlineClick()"
     class="btn btn-info  cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1"><b>COTAÇÃO
      ONLINE</b></button>
   </div>

  </div>

  <div class="card-body" *ngIf="!isCaminhao">
   <p class="card-text text-center desc-text-card-price">{{ descricao }}</p>
   <h5 class="card-title text-center  "><b>Faça sua cotação!</b></h5>

   <div class="justify-content-center ">
    <span class="desc-price-top-seguro">A partir de</span>
    <h2 class="card-price-center">{{ preco }}<span class=" cent-value">,{{ valorCentavo }}</span></h2>
    <div class="text-center" style="margin-top: -18px">
     <span class=" desc-mount mb-2" style=" margin-left: -16px !important;">{{ parcelas }} </span>
    </div>
   </div>

   <div class="d-flex justify-content-center div-top-card-seguro">
    <button type="button" (click)="onCotacaoOnlineClick()"
     class="btn btn-info  cursor-pointer box-shadow-2 round btn-min-width btn-simule mr-1 mb-1"><b>COTAÇÃO
      ONLINE</b></button>
   </div>
  </div>
 </div>
</div>